var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense, lazy, useEffect, useState } from 'react';
import useComponentBuilder from '../utils/useComponentBuilder';
import TransmitConstants from '../constants';
var AuthFlowComponent = function (props) {
    var _a = useState({
        index: 0,
        nextStep: '',
        previousAuthResponse: {}
    }), currentAuth = _a[0], setCurrentAuth = _a[1];
    var xmHandler = props.xmHandler, isLoggingEnabled = props.isLoggingEnabled, transmitsdk = props.transmitsdk, analytics = props.analytics, theme = props.theme, isQueueService = props.isQueueService, appData = props.appData, params = props.params, isVoiceEnabled = props.isVoiceEnabled, formatResponse = props.formatResponse, customUI = props.customUI, list = props.list, config = props.config, hasAnalytics = props.hasAnalytics, handleAuthResponse = props.handleAuthResponse;
    var trans_id = params.header.trans_id;
    var isPrimarySessionActive = transmitsdk === null || transmitsdk === void 0 ? void 0 : transmitsdk.currentSession;
    var auth = useComponentBuilder(currentAuth.index, currentAuth.nextStep, list);
    var path = auth.component;
    var AuthComponent = lazy(function () {
        return import("../baseComponents/".concat(path));
    });
    useEffect(function () {
        var abortController = new AbortController();
        return function cancel() {
            abortController.abort();
        };
    }, []);
    var handleCurrentSession = function () {
        if (transmitsdk === null || transmitsdk === void 0 ? void 0 : transmitsdk.currentSession) {
            isPrimarySessionActive = true;
        }
        else {
            var errorResponse = {
                status: {
                    response_code: TransmitConstants.policyResponse.systemError,
                    response_desc: TransmitConstants.responseDesc.systemError,
                    trans_id: trans_id
                },
                authentication_status: TransmitConstants.authenticationStatus.systemError,
                token: ''
            };
            handleAuthResponse(errorResponse);
        }
    };
    var handleResponse = function (authResponse) {
        if ('next_step' in authResponse) {
            if (authResponse.next_step !== '' || null) {
                var step = authResponse.next_step;
                var nextIndex = currentAuth.index + 1;
                if (authResponse.next_step !== '' || null) {
                    handleCurrentSession();
                    setCurrentAuth({
                        index: nextIndex,
                        nextStep: step,
                        previousAuthResponse: authResponse
                    });
                }
                else {
                    handleAuthResponse(authResponse);
                    return false;
                }
            }
            else {
                handleAuthResponse(authResponse);
                return false;
            }
        }
        else {
            handleAuthResponse(authResponse);
            return false;
        }
    };
    return (_jsx(Suspense, __assign({ fallback: _jsx(_Fragment, {}) }, { children: _jsx(AuthComponent, { params: params, appData: appData, handleAuthResponse: handleResponse, analytics: analytics, formatResponse: formatResponse, transmitsdk: transmitsdk, isPrimarySessionActive: isPrimarySessionActive, hasAnalytics: hasAnalytics, theme: theme, config: config, response: currentAuth.previousAuthResponse, isLoggingEnabled: isLoggingEnabled, list: list, isQueueService: isQueueService, currentAuth: currentAuth, xmHandler: xmHandler, isVoiceEnabled: isVoiceEnabled, customUI: customUI, path: path }) })));
};
export default AuthFlowComponent;
